const {
  REACT_APP_PCA_TENANT_ID = '5a661919-a609-4857-a7a7-eea01d3ecdfa',
  REACT_APP_CLIENT_ID,
  REACT_APP_SERVICE_URI,
  REACT_APP_APP_QUERY_URL,
  REACT_APP_IAR_URL
} = process.env;


export const config = {
  REACT_APP_PCA_TENANT_ID,
  REACT_APP_CLIENT_ID,
  REACT_APP_SERVICE_URI,
  REACT_APP_APP_QUERY_URL: REACT_APP_APP_QUERY_URL,
  REACT_APP_IAR_URL: REACT_APP_IAR_URL
};
